import {useMemo} from 'react';

import {selectIsFullscreen} from '~redux/reducers/annotatorReducer';
import {useAppSelector} from '~redux/index';

import {useAnnotatorPortalRoot} from './useAnnotatorPortalRoot';

export function useAnnotatorOverlayProps(): {container?: HTMLElement} {
  const isFullscreen = useAppSelector(selectIsFullscreen);
  const portalRoot = useAnnotatorPortalRoot();

  return useMemo(() => (isFullscreen ? {container: portalRoot} : {}), [isFullscreen, portalRoot]);
}
